import YhTable from './src/table.vue'

export default YhTable
